import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import TextAreaEditDisplay from 'formiojs/components/textarea/editForm/TextArea.edit.display';
import TextAreaEditValidation from 'formiojs/components/textarea/editForm/TextArea.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: TextAreaEditDisplay,
    },
    {
      key: 'validation',
      components: TextAreaEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip: 'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textarea',
          label: 'Custom Description',
          key: 'customDescription',
          input: true,
        },
        {
          weight: 150,
          type: 'textfield',
          label: 'Character Limit (Integer Value)',
          key: 'characterLimit',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip: 'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'number',
          label: 'Review character limit',
          key: 'charLimit',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
